import React, { useState } from 'react';
import { Menu } from '../../Menu';
import { useNoteTemplates } from '../../../data/useNoteTemplates';
import Unread from '../../Unread';
import { templatePreviewLine } from '../../../domain/noteTemplates';
import s from './noteTemplates.module.css';

// The `Templates` control at the foot of the lesson-note editor, as in MMS.
//
// It is a menu of saved bodies. Picking one appends it to the note being
// written — the "does not replace" promise is applyTemplate's, in
// domain/noteTemplates.js, along with why.
//
// Left-aligned, unlike Menu's default: this hangs off a control on the *left*
// of the editor, and a right-aligned panel there would run back under the text.

export default function TemplatePicker({ onApply }) {
  // `loaded` (#629): an unread list is not "No templates saved yet."
  const { templates, loaded, failed } = useNoteTemplates();
  const [open, setOpen] = useState(false);

  return (
    <Menu
      open={open}
      onClose={() => setOpen(false)}
      align="left"
      trigger={(
        <button
          type="button"
          className={s.pickerTrigger}
          aria-haspopup="menu"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          Templates ▾
        </button>
      )}
    >
      {templates.length === 0 && !loaded ? (
        <Unread failed={failed} />
      ) : templates.length === 0 ? (
        // Said rather than shown as an empty panel, and it says where the list
        // is kept: a teacher who has never opened Options has no way to guess
        // that this menu is empty because there is nothing in it yet.
        <div className={s.pickerEmpty}>
          No templates saved yet. Add them from the calendar’s
          Options → Lesson Note Templates.
        </div>
      ) : templates.map((t) => (
        <button
          key={t.id}
          type="button"
          className={s.pickerItem}
          onClick={() => { setOpen(false); onApply(t.body); }}
        >
          <span className={s.pickerLabel}>{t.label}</span>
          {/* The first line of the body, because two templates called
              "Practice" are told apart only by what is in them. */}
          <span className={s.pickerPreview}>{templatePreviewLine(t.body)}</span>
        </button>
      ))}
    </Menu>
  );
}
